import loadable from '@loadable/component';

export const GrdSiteWrapper = loadable(
  () => import(/* webpackChunkName: "grd-site" */ './GrdSiteWrapper'),
);
